export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "search.worker.b93dade150326b0f3a25.worker.js");
}
